import { ChatMessageDirection } from '@/schema'

import type { PendingMessage, ChatMessageResponse, MessageGroup } from './types'

type CreatePendingMessageParams = {
	clientId: string
	roomId: string
	messageType: ChatMessageResponse['messageType']
	text?: string
	stickerPackageId?: string
	stickerId?: string
	imagePreviewUrl?: string
	imageOriginalUrl?: string
	videoOriginalUrl?: string
	videoPreviewUrl?: string
	audioOriginalUrl?: string
	audioDuration?: number
	fileUrl?: string
	fileName?: string
}

export function createPendingMessage({
	clientId,
	roomId,
	messageType,
	text,
	stickerPackageId,
	stickerId,
	imagePreviewUrl,
	imageOriginalUrl,
	videoOriginalUrl,
	videoPreviewUrl,
	audioOriginalUrl,
	audioDuration,
	fileUrl,
	fileName,
}: CreatePendingMessageParams): PendingMessage {
	return {
		clientId,
		status: 'pending',
		message: {
			id: `pending-${clientId}`,
			clientId,
			chatRoomId: roomId,
			direction: ChatMessageDirection.OUTGOING,
			messageType,
			text,
			stickerPackageId,
			stickerId,
			imagePreviewUrl,
			imageOriginalUrl,
			videoOriginalUrl,
			videoPreviewUrl,
			audioOriginalUrl,
			audioDuration,
			fileUrl,
			fileName,
			isPinned: false,
			usedReplyToken: false,
			isRead: false,
			createdAt: new Date().toISOString(),
		},
	}
}

export function groupMessagesByDate(
	messages: ChatMessageResponse[],
): MessageGroup[] {
	const groups: MessageGroup[] = []
	let currentDate = ''

	messages.forEach((msg) => {
		const msgDate = new Date(msg.createdAt).toLocaleDateString('th-TH', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		})

		if (msgDate !== currentDate) {
			currentDate = msgDate
			groups.push({ date: msgDate, messages: [msg] })
		} else {
			groups[groups.length - 1].messages.push(msg)
		}
	})

	return groups
}

export function getMessagePreview(message: ChatMessageResponse): string {
	switch (message.messageType) {
		case 'TEXT':
			return message.text?.slice(0, 50) || ''
		case 'STICKER':
			return '[สติกเกอร์]'
		case 'IMAGE':
			return '[รูปภาพ]'
		case 'VIDEO':
			return '[วิดีโอ]'
		case 'AUDIO':
			return '[เสียง]'
		case 'FILE':
			return `[ไฟล์] ${message.fileName || ''}`
		case 'LOCATION':
			return '[ตำแหน่ง]'
		case 'SYSTEM':
			return `[System] ${message.text || ''}`
		default:
			return '[ข้อความ]'
	}
}
